import React, { useState, lazy } from 'react';
import { trackEvent } from '../utils/pixel';
/* ─── FOR WHOM ─── */
export function ForWhomSection() {
  return null;
}
/* ─── CHECKOUT FLOW (Order Bumps) ─── */
export function OrderBumpsSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 12999;
  const bump1Price = 3990;
  const bump2Price = 2990;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const productCount = 1 + (bump1 ? 1 : 0) + (bump2 ? 1 : 0);
  const formatPrice = (price: number) => {
    return '$' + price.toLocaleString('es-AR').replace(',', '.');
  };
  // Build product name list
  const productNames = ['Kit Método 3C'];
  if (bump1) productNames.push('Jugos Camuflados');
  if (bump2) productNames.push('Tabla Mágica');
  // Dynamic Shopify cart URL based on selection
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://vitaliaguides.com/cart/46678566371505:1';
    if (bump1) return 'https://vitaliaguides.com/cart/46678542844081:1';
    if (bump2) return 'https://vitaliaguides.com/cart/46678547398833:1';
    return 'https://vitaliaguides.com/cart/46678445981873:1';
  };
  const handleCheckoutClick = (e: React.MouseEvent) => {
    trackEvent('AddToCart', {
      content_name: productNames.join(' + '),
      content_type: 'product',
      value: total / 100,
      currency: 'ARS',
      num_items: productCount
    });
  };
  return <section id="order" className="py-8 px-5 sm:py-10 sm:px-6 bg-[#FDF9F3]" data-id="element-98">
      <div className="max-w-[500px] mx-auto" data-id="element-99">
        <div className="text-center mb-6" data-id="element-100">
          <p className="text-[#E85D4A] text-[12px] font-black tracking-widest uppercase mb-2" data-id="element-101">
            ⚡ PRECIO DE LANZAMIENTO ACTIVO
          </p>
          <h2 className="text-[#2C3E50] text-[22px] sm:text-[26px] font-black leading-tight" data-id="element-102">
            Acceso inmediato al comprar
          </h2>
        </div>

        {/* Mini-cards for Bumps */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-103">
          {/* Bump 1 */}
          <div className={`bg-white rounded-2xl p-3 sm:p-4 border-2 transition-all duration-200 flex items-center gap-3 sm:gap-4 ${bump1 ? 'border-[#5E8D5A] shadow-[0_4px_16px_rgba(94,141,90,0.15)]' : 'border-[#E67E22]/40 shadow-sm'}`} data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/5ikgyziXYvZ1ZbuASTqmxf/Order_1.png" alt="Jugos Camuflados" className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-105" />
            <div className="flex-1 min-w-0" data-id="element-106">
              <h3 className="text-[#2C3E50] text-[14px] sm:text-[15px] font-black leading-tight mb-1" data-id="element-107">
                SÍ, SUMAR JUGOS CAMUFLADOS
              </h3>
              <p className="text-[#6B7280] text-[12px] sm:text-[13px] leading-snug mb-1.5" data-id="element-108">
                Lográ que reciba todas sus vitaminas en un solo vaso, sin que se
                dé cuenta. Ideal para los días de poco tiempo.
              </p>
              <p className="text-[#5E8D5A] text-[13px] sm:text-[14px] font-black mb-2" data-id="element-109">
                + $3.990{' '}
                <span className="text-[#E67E22] text-[11px] font-bold" data-id="element-110">
                  (Ahorrá 70% hoy)
                </span>
              </p>
              <button onClick={() => setBump1(!bump1)} className={`text-[11px] sm:text-[12px] font-black uppercase tracking-wider py-1.5 px-3 rounded-lg w-full transition-colors ${bump1 ? 'bg-[#5E8D5A]/10 text-[#5E8D5A]' : 'bg-[#E67E22]/10 text-[#E67E22] hover:bg-[#E67E22]/20'}`} data-id="element-111">
                {bump1 ? '✓ AGREGADO' : 'SUMAR AHORA'}
              </button>
            </div>
          </div>

          {/* Bump 2 */}
          <div className={`bg-white rounded-2xl p-3 sm:p-4 border-2 transition-all duration-200 flex items-center gap-3 sm:gap-4 ${bump2 ? 'border-[#5E8D5A] shadow-[0_4px_16px_rgba(94,141,90,0.15)]' : 'border-gray-100 shadow-sm'}`} data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/5S8q3Am1n5fvFMmzJUBx2H/Order_2.png" alt="Tabla Mágica" className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-113" />
            <div className="flex-1 min-w-0" data-id="element-114">
              <h3 className="text-[#2C3E50] text-[14px] sm:text-[15px] font-black leading-tight mb-1" data-id="element-115">
                SÍ, SUMAR TABLA MÁGICA
              </h3>
              <p className="text-[#6B7280] text-[12px] sm:text-[13px] leading-snug mb-1.5" data-id="element-116">
                El juego interactivo que reduce la ansiedad y hace que se anime
                a probar texturas nuevas jugando.
              </p>
              <p className="text-[#5E8D5A] text-[13px] sm:text-[14px] font-black mb-2" data-id="element-117">
                + $2.990{' '}
                <span className="text-[#E85D4A] text-[11px] font-bold" data-id="element-118">
                  (Única oportunidad)
                </span>
              </p>
              <button onClick={() => setBump2(!bump2)} className={`text-[11px] sm:text-[12px] font-black uppercase tracking-wider py-1.5 px-3 rounded-lg w-full transition-colors ${bump2 ? 'bg-[#5E8D5A]/10 text-[#5E8D5A]' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-119">
                {bump2 ? '✓ AGREGADO' : 'SUMAR AHORA'}
              </button>
            </div>
          </div>
        </div>

        {/* Dynamic Summary */}
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 mb-6" data-id="element-120">
          <div className="flex justify-between items-end mb-2" data-id="element-121">
            <div data-id="element-122">
              <p className="text-gray-500 text-[12px] font-bold uppercase tracking-wider mb-1" data-id="element-123">
                TOTAL A PAGAR
              </p>
              <p className="text-[#2C3E50] text-[13px] font-semibold" data-id="element-124">
                {productCount} {productCount === 1 ? 'producto' : 'productos'}
              </p>
            </div>
            <div className="text-[#2C3E50] text-[32px] font-black leading-none" data-id="element-125">
              {formatPrice(total)}
            </div>
          </div>
        </div>

        {/* Guarantee Text Above CTA */}

        {/* CTA Button */}
        <a href={getCheckoutUrl()} onClick={handleCheckoutClick} className="w-full block text-white rounded-2xl py-4 px-5 transition-all duration-200 hover:bg-[#d67118] hover:-translate-y-0.5 text-center no-underline bg-[#F39C12]" style={{
        boxShadow: '0 12px 32px rgba(230,126,34,0.3)'
      }} data-id="element-126">
          <span className="text-[16px] sm:text-[18px] font-black block" data-id="element-127">
            SÍ, QUIERO PAZ EN MI MESA — {formatPrice(total)}
          </span>
        </a>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mt-5 text-gray-500 text-[12px] font-semibold" data-id="element-128">
          <span data-id="element-129">🔒 Acceso inmediato</span>
          <span data-id="element-130">💳 Pago seguro</span>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/w5y4NrCNFhtKGREXWxX61b/metodos_de_pago.png" alt="Métodos de pago: Mercado Pago, Visa, MasterCard" className="mx-auto mt-5 w-full object-contain opacity-80" loading="lazy" decoding="async" data-id="element-131" />
      </div>
    </section>;
}
/* ─── GUARANTEE ─── */
export function GuaranteeSection() {
  return <section className="bg-[#FDF9F3] py-6 px-5 sm:py-8 sm:px-6" data-id="element-132">
      <div className="max-w-[500px] mx-auto" data-id="element-133">
        <div className="bg-white rounded-2xl p-5 sm:p-6 border-2 border-[#5E8D5A] text-center shadow-sm" data-id="element-134">
          <div className="text-3xl mb-2 leading-none" data-id="element-135">🛡️</div>
          <h2 className="text-[#2C3E50] text-[18px] font-black mb-1" data-id="element-136">
            30 días de garantía
          </h2>
          <p className="text-[#5E8D5A] font-bold text-[12px] font-[Avenir,_sans-serif]" data-id="element-137">
            Si en 30 días no lográs que pruebe su primera verdura, te devolvemos
            el 100% de tu dinero sin preguntas. Sin preguntas. Sin drama.
          </p>
        </div>
      </div>
    </section>;
}
/* ─── URGENCY ─── */
export function UrgencySection() {
  return null;
}
/* ─── FINAL CTA ─── */
export function FinalCTASection() {
  return <section id="cta" style={{
    background: 'linear-gradient(135deg, #2C3E50, #34495e)'
  }} className="py-10 px-5 sm:py-12 sm:px-6 text-center" data-id="element-138">
      <div className="max-w-[500px] mx-auto" data-id="element-139">
        <h2 className="text-white text-[26px] sm:text-[30px] font-black mb-4 leading-tight" data-id="element-140">
          La próxima comida puede ser diferente.
        </h2>
        <p className="text-white/80 text-[15px] leading-relaxed mb-8" data-id="element-141">
          No porque tu hijo madure. No porque de repente le guste. Sino porque
          vos vas a saber exactamente cómo presentarla.
        </p>
        <div className="mb-8" data-id="element-142">
          <span className="text-white/40 text-sm line-through block mb-1" data-id="element-143">
            $30.800
          </span>
          <span className="text-[#F5C842] text-[42px] font-black block leading-none" data-id="element-144">
            $12.999
          </span>
          <span className="text-[#27AE60] text-[18px] sm:text-[20px] font-black block mt-2" data-id="element-145">
            Ahorrás $17.801
          </span>
        </div>
        <a href="#order" className="bg-[#E67E22] text-white text-[16px] font-black py-4 px-8 rounded-2xl block w-full transition-all duration-200 hover:bg-[#d67118] hover:-translate-y-0.5" style={{
        boxShadow: '0 12px 32px rgba(230,126,34,0.3)'
      }} data-id="element-146">
          SÍ, QUIERO PAZ EN MI MESA →
        </a>
      </div>
    </section>;
}
/* ─── WHATSAPP TESTIMONIALS ─── */
export function WhatsAppTestimonialsSection() {
  const testimonials = [{
    name: 'Carla',
    img: 'https://cdn.magicpatterns.com/uploads/qBeAp9Q3ep6rcdWe4PDvhx/CARLA.png'
  }, {
    name: 'Florencia',
    img: 'https://cdn.magicpatterns.com/uploads/myhcDtZLL5dvmdkTEDDccQ/FLORENCIA.png'
  }, {
    name: 'Valentina',
    img: 'https://cdn.magicpatterns.com/uploads/1J1DozQ5HATUFBJWhFPbug/VALENTINA.png'
  }];
  return <section className="bg-[#FDF9F3] py-8 px-5 sm:py-10 sm:px-6" data-id="element-147">
      <div className="max-w-[720px] mx-auto" data-id="element-148">
        <p className="text-[#5E8D5A] text-[11px] sm:text-[12px] font-black tracking-[2px] text-center uppercase mb-1.5" data-id="element-149">
          💬 TESTIMONIOS REALES
        </p>
        <h2 className="text-[#2C3E50] text-[22px] sm:text-[26px] font-black text-center mb-6 leading-tight tracking-tight" data-id="element-150">
          Lo que dicen quienes ya usaron el método
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-151">
          {testimonials.map((t, i) => <div key={i} className="rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.10)] bg-white" data-id="element-152">
              <img src={t.img} alt={`Testimonio de ${t.name} por WhatsApp`} className="w-full h-auto object-contain" loading="lazy" data-id="element-153" />
            </div>)}
        </div>
      </div>
    </section>;
}
/* ─── FAQ ─── */
const faqs = [{
  q: '¿Para qué edades sirve?',
  a: 'Diseñado específicamente para nenes de 3 a 12 años que presentan selectividad alimentaria o rechazo a texturas nuevas.'
}, {
  q: '¿Es un curso o un libro?',
  a: 'Es un Kit Digital Completo. Recibís la Guía Maestra + 5 Bonos descargables para ver en tu celu, tablet o compu para siempre.'
}, {
  q: 'No tengo tiempo de cocinar raro, ¿me sirve?',
  a: '¡Sí! El Método 3C se basa en comida real y técnicas de presentación que te ahorran tiempo, no te lo quitan.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato. Apenas se acredita el pago, recibís un mail con el link de descarga para empezar hoy mismo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#F4F4F4] py-8 px-5 sm:py-10 sm:px-6" data-id="element-154">
      <div className="max-w-[500px] mx-auto" data-id="element-155">
        <h2 className="text-[#2C3E50] text-[24px] sm:text-[28px] font-black text-center mb-6 leading-tight" data-id="element-156">
          Preguntas Frecuentes
        </h2>
        <div className="flex flex-col gap-3" data-id="element-157">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl p-4 sm:p-5 cursor-pointer border border-gray-100 shadow-sm" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-158">
              <div className="flex justify-between items-center gap-4" data-id="element-159">
                <span className="text-[#2C3E50] text-[15px] font-bold leading-snug" data-id="element-160">
                  {faq.q}
                </span>
                <span className={`text-[#5E8D5A] text-xl flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-161">
                  +
                </span>
              </div>
              {openIndex === i && <p className="text-[#6B7280] text-[14px] leading-relaxed mt-3 pt-3 border-t border-gray-50" data-id="element-162">
                  {faq.a}
                </p>}
            </div>)}
        </div>
      </div>
    </section>;
}
/* ─── FOOTER ─── */
export function FooterSection() {
  return <footer className="bg-white py-10 px-5 sm:px-6 text-center border-t border-gray-100" data-id="element-163">
      <div className="max-w-[500px] mx-auto" data-id="element-164">
        <div className="text-[#2C3E50] text-lg font-black mb-4 tracking-tight" data-id="element-165">
          VITALIA guides 🌿
        </div>
        <div className="flex justify-center items-center flex-wrap gap-4 mb-6" data-id="element-166">
          <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-167">
            🛡️ Garantía 30 días
          </span>
          <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-168">
            💳 Pago seguro
          </span>
        </div>
        <div className="text-gray-400 text-[12px] mb-3 flex justify-center gap-3" data-id="element-169">
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-170">
            Privacidad
          </a>
          <span data-id="element-171">·</span>
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-172">
            Términos
          </a>
        </div>
        <div className="text-gray-300 text-[11px]" data-id="element-173">© 2026 Vitalia Guides</div>
      </div>
    </footer>;
}